import { render } from "./positionInfo.vue?vue&type=template&id=de1887b2&scoped=true"
import script from "./positionInfo.vue?vue&type=script&lang=js"
export * from "./positionInfo.vue?vue&type=script&lang=js"

import "./positionInfo.vue?vue&type=style&index=0&id=de1887b2&lang=scss&scoped=true"

import exportComponent from "D:\\jll-web-xintan\\xinfu-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de1887b2"]])

export default __exports__